/**
 * Fix merged street + city when a comma/line break was lost (e.g. CenterOak -> Center, Oak).
 */
(function () {
  "use strict";

  function normalizeLocationAddress(address) {
    var s = String(address || "").trim();
    if (!s) return s;
    if (/[a-z][A-Z]/.test(s)) {
      s = s.replace(/([a-z])([A-Z][a-z]{2,})/, "$1, $2");
    }
    return s.replace(/\s+/g, " ").replace(/\s*,\s*/g, ", ").trim();
  }

  window.tricociNormalizeLocationAddress = normalizeLocationAddress;

  function formatVisitHeadings() {
    document.querySelectorAll("[data-seo-visit-address]").forEach(function (el) {
      var raw = el.getAttribute("data-seo-visit-address") || el.textContent;
      var fixed = normalizeLocationAddress(raw);
      if (fixed) el.textContent = fixed;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", formatVisitHeadings);
  } else {
    formatVisitHeadings();
  }
})();
